import { IApplication, IApplicationRoot, IProduct } from '../../models';
import {
  AppActions,
  HandleNextClick,
  HandleResultSelectedClick,
  SetInputSuccss
} from '../actions/appActions';

export interface IAppReducerState {
  applicationRoot: IApplicationRoot;
  application: IApplication | null;
  inputs: Map<string, string>;
  stepIndex: number;
  selection: Map<string, string> | null;
  showResults: boolean;
  stack: IAppReducerState[];
  productToBeSelected: IProduct | null;
  selectedProduct: IProduct | null;
  techData: any;
}

export const INITIAL_STATE: IAppReducerState = {
  application: null,
  inputs: new Map(),
  selection: null,
  applicationRoot: {} as IApplicationRoot,
  stepIndex: 0,
  showResults: false,
  stack: [],
  productToBeSelected: null,
  selectedProduct: null,
  techData: null
};

export default (state: IAppReducerState = INITIAL_STATE, action: AppActions): IAppReducerState => {
  switch (action.type) {
    case 'set_application_success':
      const { application } = action;
      const copy = { ...application } as IApplication;
      return {
        ...state,
        application: copy,
        inputs: new Map<string, string>([['Application', copy ? copy.name : '']]),
        stack: [...state.stack, state]
      };
    case 'set_input_success':
      return setInputs(state, action);
    case 'next_click_success':
      return handleNextClickSucces(state, action);
    case 'previous_click_success':
      return handlePreviousClickSuccess(state);
    case 'reset_click_success':
      return handleResetClickSuccess(state);
    case 'showresults_click_success':
      return handleShowResultsClickSuccess(state);
    case 'resultselected_click_success':
      return handleResultSelectedClickSuccess(state, action);
    default:
      return state;
  }
};

const setInputs = (state: IAppReducerState, action: SetInputSuccss): IAppReducerState => {
  const { inputs } = action;

  const newInputs = new Map<string, string>();

  inputs.forEach((value: string, key: string) => {
    newInputs.set(key, value);
  });

  newInputs.set('Application', state.application ? state.application.name : '');

  return {
    ...state,
    inputs: newInputs
  };
};

const handleNextClickSucces = (state: IAppReducerState, action: HandleNextClick): IAppReducerState => {
  const { filters } = action;
  const newMap = new Map<string, string>([...state.inputs, ...filters]);
  const newState = {
    ...state,
    inputs: newMap
  };

  if (state.productToBeSelected) {
    return {
      ...newState,
      stack: [...state.stack, state],
      selectedProduct: state.productToBeSelected
    };
  }
  else if (state && state.application && (newState.stepIndex + 1) >= state.application.steps.length) {
    return {
      ...newState,
      stack: [...state.stack, state],
      showResults: true
    };
  }
  else {
    return {
      ...newState,
      stepIndex: state.stepIndex + 1,
      stack: [...state.stack, state]
    };
  }
};

const handlePreviousClickSuccess = (state: IAppReducerState): IAppReducerState => {
  return {
    ...state.stack[state.stack.length - 1],
    stack: state.stack.slice(0, -1)
  };
};

const handleResetClickSuccess = (state: IAppReducerState): IAppReducerState => {
  const applicationRoot = state.applicationRoot;
  const techData = state.techData;
  const newState = INITIAL_STATE;
  return {
    ...newState,
    applicationRoot,
    techData,
    application: null,
    inputs: new Map<string, string>(),
    stack: []
  };
};

const handleShowResultsClickSuccess = (state: IAppReducerState): IAppReducerState => {
  const newState = {
    ...state,
    showResults: true
  };

  return {
    ...newState,
    stack: [...state.stack, state]
  };
};

const handleResultSelectedClickSuccess = (
  state: IAppReducerState,
  action: HandleResultSelectedClick): IAppReducerState => {
  const { product } = action;
  if (product === null) return state;

  return {
    ...state,
    productToBeSelected: product
  };
};
